/* tslint:disable */
/* eslint-disable */
/**
 * my-b2cweb-customer-auth
 * API Service - Customer Auth
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export const BASE_PATH = 'http://localhost'.replace(/\/+$/, '');
/**
 * Below resources will be export from shared library
 */
export { COLLECTION_FORMATS, BaseAPI, RequiredError } from '@pimy-b2cweb/apiclient-common';
